import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import css from './NoSearchResultsMaybe.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, location, resetAll, isFemx, intl } = props;
  const history = useHistory();
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;
  if (isFemx && hasNoResult) {
    return (
      <div>
        <h4 className={css.name}>
          <FormattedMessage id="NoResultFound.ForFemxProfile" />
        </h4>
        <p className={css.introLink}>
          {intl.formatMessage(
            { id: 'NoResultFound.ForFemxProfileSubHeader' },
            {
              link: (
                <span
                  className={css.link}
                  onClick={() => history.push('/s?pub_listingType=fem-x-profile')}
                >
                  <FormattedMessage id="NoResultFound.explore" />
                  
                </span>
              ),
            }
          )}
        </p>
      </div>
    );
  }
  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <FormattedMessage id="SearchPage.noResults" />
      <br />
      {hasSearchParams ? (
        <button className={css.resetAllFiltersButton} onClick={e => resetAll(e)}>
          <FormattedMessage id={'SearchPage.resetAllFilters'} />
        </button>
      ) : null}
      <p>
        <NamedLink className={css.createListingLink} name="NewListingPage">
          <FormattedMessage id="SearchPage.createListing" />
        </NamedLink>
      </p>
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
